import EpdDetails from 'components/v2/copy/epd-details/EpdDetails';
import EpdPanelHeaderTemplate from 'components/v2/copy/header/EpdPanelHeaderTemplate';
import React, { useState } from 'react';
import { EPDCopyGroupStatus, EpdCopyGroupWizardModel, EPDModel, FileLoadingModel } from 'services/EpdClient';
import { EpdItemPanel } from 'styles/v2/Styles.styled';

const EpdItem: React.FunctionComponent<{
  epd: EPDModel;
  groupData: EpdCopyGroupWizardModel;
  isConstruction: boolean;
  onChangeEpd(name: string, value: any): Promise<void>;
  onUploadFile(epdId: string | undefined, field: string, file: File, documentTypeId: string | null, documentLanguageId: string | null): void;
  onRemoveFile(fileId: string): Promise<void>;
  refetchGroupData: any;
  refreshEPD(epdId: string): Promise<void>;
  onConfirmUpdate: any;
  isReadOnly: boolean;
  canUpload: boolean;
  fileLoading?: FileLoadingModel[];
  isMenuEnabled: boolean;
  groupStatus: EPDCopyGroupStatus;
}> = ({
  epd,
  groupData,
  isConstruction,
  onChangeEpd,
  onUploadFile,
  onRemoveFile,
  refetchGroupData,
  refreshEPD,
  onConfirmUpdate,
  isReadOnly,
  canUpload,
  fileLoading,
  isMenuEnabled,
  groupStatus,
}) => {
  const [title, setTitle] = useState<string | undefined>(epd.title);

  return (
    <EpdItemPanel
      headerTemplate={(options) => (
        <EpdPanelHeaderTemplate
          options={options}
          epd={epd}
          groupData={groupData}
          onChangeEpd={onChangeEpd}
          refetchGroupData={refetchGroupData}
          title={title}
          setTitle={setTitle}
          onConfirmUpdate={onConfirmUpdate}
          isReadOnly={isReadOnly}
          isMenuEnabled={isMenuEnabled}
          groupStatus={groupStatus}
        />
      )}
      toggleable
      collapsed
    >
      <EpdDetails
        epd={epd}
        onChangeEpd={onChangeEpd}
        onUploadFile={(field, file, documentTypeId, documentLanguageId) => onUploadFile(epd.id, field, file, documentTypeId, documentLanguageId)}        
        onRemoveFile={onRemoveFile}
        isConstruction={isConstruction}
        title={title}
        setTitle={setTitle}
        isReadOnly={isReadOnly}
        canUpload={canUpload}
        fileLoading={fileLoading}
        refreshEPD={refreshEPD}
      />
    </EpdItemPanel>
  );
};

export default EpdItem;
